export enum COST_DOCUMENT_CONTROLLERS {
  Other = 1,
  Commercial = 2,
}
